module.exports = __webpack_public_path__ + "img/home_atrategy__img2.09741f8d.png";